var _mask, _path, _path2, _mask2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_752_2734",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 9.5625H5C4.6925 9.5625 4.4375 9.3075 4.4375 9C4.4375 8.6925 4.6925 8.4375 5 8.4375H14C14.3075 8.4375 14.5625 8.6925 14.5625 9C14.5625 9.3075 14.3075 9.5625 14 9.5625Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 9.5625H5C4.6925 9.5625 4.4375 9.3075 4.4375 9C4.4375 8.6925 4.6925 8.4375 5 8.4375H14C14.3075 8.4375 14.5625 8.6925 14.5625 9C14.5625 9.3075 14.3075 9.5625 14 9.5625Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8.0625H5V11.0625H14V8.0625ZM5 8.0625C5.52093 8.0625 5.9375 8.47907 5.9375 9H2.9375C2.9375 10.1359 3.86407 11.0625 5 11.0625V8.0625ZM5.9375 9C5.9375 9.52093 5.52093 9.9375 5 9.9375V6.9375C3.86407 6.9375 2.9375 7.86407 2.9375 9H5.9375ZM5 9.9375H14V6.9375H5V9.9375ZM14 9.9375C13.4791 9.9375 13.0625 9.52093 13.0625 9H16.0625C16.0625 7.86407 15.1359 6.9375 14 6.9375V9.9375ZM13.0625 9C13.0625 8.47907 13.4791 8.0625 14 8.0625V11.0625C15.1359 11.0625 16.0625 10.1359 16.0625 9H13.0625Z",
    fill: "white",
    mask: "url(#path-1-inside-1_752_2734)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_752_2734",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 14.0625C9.1925 14.0625 8.9375 13.8075 8.9375 13.5V4.5C8.9375 4.1925 9.1925 3.9375 9.5 3.9375C9.8075 3.9375 10.0625 4.1925 10.0625 4.5V13.5C10.0625 13.8075 9.8075 14.0625 9.5 14.0625Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 14.0625C9.1925 14.0625 8.9375 13.8075 8.9375 13.5V4.5C8.9375 4.1925 9.1925 3.9375 9.5 3.9375C9.8075 3.9375 10.0625 4.1925 10.0625 4.5V13.5C10.0625 13.8075 9.8075 14.0625 9.5 14.0625Z",
    fill: "#292D32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 12.5625C10.0209 12.5625 10.4375 12.9791 10.4375 13.5H7.4375C7.4375 14.6359 8.36407 15.5625 9.5 15.5625V12.5625ZM10.4375 13.5V4.5H7.4375V13.5H10.4375ZM10.4375 4.5C10.4375 5.02093 10.0209 5.4375 9.5 5.4375V2.4375C8.36407 2.4375 7.4375 3.36407 7.4375 4.5H10.4375ZM9.5 5.4375C8.97907 5.4375 8.5625 5.02093 8.5625 4.5H11.5625C11.5625 3.36407 10.6359 2.4375 9.5 2.4375V5.4375ZM8.5625 4.5V13.5H11.5625V4.5H8.5625ZM8.5625 13.5C8.5625 12.9791 8.97907 12.5625 9.5 12.5625V15.5625C10.6359 15.5625 11.5625 14.6359 11.5625 13.5H8.5625Z",
    fill: "white",
    mask: "url(#path-3-inside-2_752_2734)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.51b5dd31a63d85c35b821db633251350.svg";
export { ForwardRef as ReactComponent };